import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, faLaptopCode } from '@fortawesome/free-solid-svg-icons'
import logo from '../img/logoTwo.png'
import home from "../img/manhome.png";
import './NavBar.css'
import { Link } from 'react-router-dom'
import aos from "aos";
import "aos/dist/aos.css";
const NavBar = () => {

  
  useEffect(() => {
    aos.init({ duration: 2000 });
  }, []);


    return (
    
        <div style={{backgroundColor:"#000"}} className="container">
        
<nav style={{backgroundColor:"#000"}} data-aos="fade-right" className="navbar navbar-expand-lg navbar-light  p-3  ">
  <div className="container-fluid">
    <Link className="navbar-brand " to="/">
     <strong className="text-white text-bold">💻Rian Islam</strong>
</Link>
    <button className="navbar-toggler bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div  className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto  mb-2 mb-lg-0">
        <li className="nav-item px-3">
          <Link className="nav-link text-white active" aria-current="page" to="/">Home</Link>
        </li>
        {/* <li className="nav-item px-3">
          <Link className="nav-link text-white active" aria-current="page" to="/home">Home</Link>
        </li> */}
        <li className="nav-item px-3">
          <Link className="nav-link text-white" to="/working">Working</Link>
        </li>
        <li className="nav-item px-3">
          <Link className="nav-link text-white" to="/blogs">Blogs</Link>
        </li>
        <li className="nav-item  px-3">
          <Link className="nav-link text-white" to="/Projects">Projects</Link>
        </li>
        <li className="nav-item px-3">
          <Link className="nav-link text-white" to="/Skills">Skills</Link>
        </li>
        <li className="nav-item px-3">
          <Link className="nav-link text-white" to="/Tools">Tools</Link>
        </li>
        
        <li className="nav-item  px-3">
          <Link className="nav-link text-white" to="/About">About</Link>
        </li>
        <li className="nav-item  px-3">
          <Link className="nav-link text-white" to="/Contact">Contact</Link>
        </li>
        
        
      </ul>
      
    </div>
  </div>
</nav>

        </div>
      
    )
}

export default NavBar
